module.exports = "<div class=form-control> {{#if unvisible}} <a href=javascript:void(0); class=info>权限受限</a> {{else if be_control_condition }} <a href=javascript:void(0); class=info>被修改条件限制</a> {{else}} <div class=year style=float:left;width:100px></div> <span style=float:left> &nbsp;年 &nbsp;</span> <div class=month style=float:left;width:100px></div> <span style=float:left> &nbsp;月</span> <div style=float:left class=form-print-icon> {{#if required}} <span id=requiredLogo class={{requiredClass}}></span> {{/if}} </div> {{/if}} </div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/form/year-month-control/year-month-control.html
// module id = 1964
// module chunks = 50